export default __webpack_public_path__ + "static/media/copy_icon_grey.975850ff.svg";